import React from "react";
import { Box } from "@mui/material";
import useLogin from "./hooks/useLogin";
import LoginHeroColumn from "./components/LoginHeroColumn";
import LoginFormPanel from "./components/LoginFormPanel";
import LoginFixedFooterTabs from "./components/LoginFixedFooterTabs";
import LoginAccountSelectionDialog from "./components/LoginAccountSelectionDialog";
import LoginCalculatorDialog from "./components/LoginCalculatorDialog";
import SupportContactDialog from "../../components/SupportContactDialog";

const Login = () => {
  const login = useLogin();

  return (
    <Box
      display="flex"
      flexDirection="row"
      height="100vh"
      sx={{
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Left Column - Hero Section */}
      <LoginHeroColumn isMobile={login.isMobile} />

      {/* Right Column - Login Form */}
      <LoginFormPanel login={login} />

      {/* Calculator Tab at Bottom */}
      <LoginFixedFooterTabs
        setOpenSupport={login.setOpenSupport}
        setOpenCalculator={login.setOpenCalculator}
      />

      <SupportContactDialog
        open={login.openSupport}
        onClose={() => login.setOpenSupport(false)}
        context="Login"
      />

      <LoginAccountSelectionDialog
        open={login.showAccountSelection}
        onClose={() => login.setShowAccountSelection(false)}
        accountsList={login.accountsList}
        handleAccountSelect={login.handleAccountSelect}
        primaryColor={login.primaryColor}
      />

      <LoginCalculatorDialog
        open={login.openCalculator}
        onClose={() => login.setOpenCalculator(false)}
        primaryColor={login.primaryColor}
      />

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes float {
          0%,
          100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
      `}</style>
    </Box>
  );
};

export default Login;
